if (typeof window === 'undefined')
  global.window = { location: { host: 'testhost' } }

const maps = {
  'bedee-web.bdms.tech': 'production',
  'uat-bedee-web.bdms.tech': 'uat',
  'qa-bedee-web.bdms.tech': 'qa',
  'dev-bedee-web.bdms.tech': 'develop',
}

const host = window.location.host
const found = maps[host]

const env = found ? found : 'localhost'
export const config = require(`./config.${env}`)
